import React from 'react';
import ReactDOM from 'react-dom/client';
import { ShopifyProvider } from './contexts/ShopifyContext';
import { AuthProvider } from './contexts/AuthContext';
import { Router } from './Router';
import { registerPaccoServiceWorker } from './lib/serviceWorker';
import { installStoreMonitorReporter } from './lib/storeMonitorReporter';
import { mark } from './lib/perf/marks';
import { initAnalytics } from './lib/analytics';
import { startIabDiag } from './lib/iabDiag';
import './styles/global.css';

mark('app-boot');

// Diagnostico de navegador in-app (Instagram/Facebook): so na sandbox, sem envio ao servidor.
startIabDiag();

// GTM/Clarity do Turbine: so nas rotas publicas, fora do caminho critico (ver lib/analytics).
initAnalytics();

// Kick off SW registration in the background — GLB + texture cache warms up
// on first visit, pays off on every subsequent step transition and return.
void registerPaccoServiceWorker();

// Reporta erros reais do customizador para o Store Monitor (quando embutido).
installStoreMonitorReporter();

mark('react-mount');
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ShopifyProvider>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </ShopifyProvider>
  </React.StrictMode>
);
